export enum SessionStatusEnum {
  INSESSION = 'in_session',
  OFFLINE = 'offline',
  AVAILABLE = 'available',
}
